import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { path: '/', label: '首页' },
  { path: '/category/romance', label: '分类' },
  { path: '/about', label: '关于我们' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 40);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location]);

  const isActive = (path: string) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6">
        <div className="max-w-[1400px] mx-auto flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2 group">
            <span className="font-heading text-2xl font-bold text-primary-500 tracking-tight">
              韩漫
            </span>
            <span className="font-heading text-lg font-medium text-foreground-700 group-hover:text-foreground-900 transition-colors hidden sm:inline">
              网站
            </span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`relative px-4 py-2 text-sm font-medium rounded-full transition-all duration-200 whitespace-nowrap ${
                  isActive(link.path)
                    ? 'text-primary-600 bg-primary-100/80'
                    : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-200/60'
                }`}
              >
                {link.label}
                {isActive(link.path) && (
                  <span className="absolute bottom-1 left-1/2 -translate-x-1/2 w-1 h-1 rounded-full bg-primary-500" />
                )}
              </Link>
            ))}
          </div>

          {/* Search + Mobile Toggle */}
          <div className="flex items-center gap-2">
            <button
              className="hidden md:flex items-center gap-2 px-4 py-2 rounded-full bg-background-100 border border-background-200/70 text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer"
              aria-label="搜索漫画"
            >
              <i className="ri-search-line text-base" />
              <span className="text-sm">搜索漫画...</span>
            </button>

            {/* Mobile menu button */}
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="md:hidden w-10 h-10 flex items-center justify-center rounded-full bg-background-100 border border-background-200/70 text-foreground-600 hover:text-foreground-900 transition-colors cursor-pointer"
              aria-label={mobileMenuOpen ? '关闭菜单' : '打开菜单'}
            >
              <i className={`text-lg ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`} />
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden border-t border-background-200/50 bg-background-50/98 backdrop-blur-md">
            <div className="max-w-[1400px] mx-auto px-4 py-3 flex flex-col gap-1">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
                    isActive(link.path)
                      ? 'bg-primary-100/80 text-primary-600'
                      : 'text-foreground-600 hover:bg-background-200/60 hover:text-foreground-900'
                  }`}
                >
                  {link.label}
                </Link>
              ))}
              <div className="px-4 py-2 mt-1">
                <div className="flex items-center gap-2 px-3 py-2 rounded-lg bg-background-100 border border-background-200/70 text-foreground-500">
                  <i className="ri-search-line text-base" />
                  <span className="text-sm">搜索漫画...</span>
                </div>
              </div>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}